module.exports = __webpack_public_path__ + "img/NCB_xiwen_2021.e40677cc.jpg";